export enum ContractStatesEnumeration {
  CONTRACTUAL = 'CONTRACTUAL',
  OTP = 'OTP',
  PRECONTRACTUAL = 'PRECONTRACTUAL',
}
